import { Button } from "@/components/ui/button";
import { Save, Mail, CheckCircle } from "lucide-react";
import { BTN } from "@/components/common/btn";
import { WOCompleteButton } from "./WOCompleteButton";

// Action buttons shown when the WO is in `submitted` status — same
// shape as Draft (existing-WO branch).
export function WOSubmittedActions({
  handleSave, openEmailDialog,
  confirmWOComplete, setConfirmWOComplete,
}) {
  return (
    <>
      <Button size="sm" className={BTN.write} onClick={() => handleSave()} title="Save" data-testid="btn-save-wo">
        <Save className="w-3.5 h-3.5" />
      </Button>
      <Button size="sm" className={BTN.internal} onClick={() => openEmailDialog("submit")} data-testid="btn-resend-email">
        <Mail className="w-3.5 h-3.5 mr-1" /> WO
      </Button>
      <Button size="sm" className={BTN.write} onClick={() => handleSave("approved")} data-testid="btn-approve-wo">
        <CheckCircle className="w-3.5 h-3.5 mr-1" /> Approve
      </Button>
      <WOCompleteButton
        confirmWOComplete={confirmWOComplete}
        setConfirmWOComplete={setConfirmWOComplete}
        onConfirm={() => handleSave("completed")}
      />
    </>
  );
}
